import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { getPath, SETTINGS_COMPANY_PATH } from 'constants/routes';
import { accountIdSelector, isAccountOwnerSelector } from 'store/user/selectors';

export const useGuestFormBlockedOverlay = () => {
  const accountId = useSelector(accountIdSelector);
  const isAccountOwner = useSelector(isAccountOwnerSelector);
  const buttonText = isAccountOwner ? 'Open Settings' : 'Contact';

  const handleButtonClick = useCallback(() => {
    window.open(getPath(SETTINGS_COMPANY_PATH, { accountId }) + '#privacy-policy');
  }, [accountId]);

  return {
    isAccountOwner,
    buttonText,
    handleButtonClick,
  };
};
